/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1ExamTypes200,
  GetApiV1ExamTypes401,
  GetApiV1ExamTypes500,
  GetApiV1ExamTypesQueryResponse,
} from "../../types/examEvaluationController/GetApiV1ExamTypes.ts";
import { dropDownListViewModelSchema } from "../dropDownListViewModelSchema.ts";

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1ExamTypes200Schema = z.array(
  z.lazy(() => dropDownListViewModelSchema),
) as unknown as ToZod<GetApiV1ExamTypes200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1ExamTypes401Schema =
  z.any() as unknown as ToZod<GetApiV1ExamTypes401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1ExamTypes500Schema =
  z.any() as unknown as ToZod<GetApiV1ExamTypes500>;

export const getApiV1ExamTypesQueryResponseSchema = z.lazy(
  () => getApiV1ExamTypes200Schema,
) as unknown as ToZod<GetApiV1ExamTypesQueryResponse>;
